const swiper = new Swiper(".swiper.marque", {
  loop: true,
  slidesPerView: "6",
  freeMode: true,
  freeModeMomentum: false,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  allowTouchMove: false,

  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    500: {
      slidesPerView: 2,
    },
    749: {
      slidesPerView: 3,
    },
    989: {
      slidesPerView: 5,
    },
  },
});

// const fr_swiper = new Swiper(".fr-swiper", {
//   slidesPerView: 4,
//   spaceBetween: 24,
//   loop: false,
//   freeMode: true,
//   freeModeMomentum: false,
//   speed: 5000,
//   pagination: {
//     el: ".fr-swiper-pagination",
//     clickable: true,
//   },
//   breakpoints: {
//     0: {
//       slidesPerView: 1,
//       spaceBetween: 16,
//     },
//     500: {
//       slidesPerView: 2,
//       spaceBetween: 20,
//     },
//     750: {
//       slidesPerView: 4,
//       spaceBetween: 24,
//     },
//   },
// });
